import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'tanok';
import { t } from 'c-3po';
import {
    BESIDA_ROLE_COMPANY,
    BESIDA_ROLE_BUYER,
} from '@evo/chat-core';

import * as a from '../../../libs/actions';
import * as u from '../../../libs/utils';
import * as agg from '../../../libs/aggregation';

import { toJS } from '../../helpers/ImmutableToJS';

import { Tabs } from '../../ui/tabs';


class RoleSwitcherView extends React.Component {
    static propTypes = {
        type: PropTypes.string,
    };

    handleChangeRole = (role) => {
        return () => {
            if (role === this.props.userRole) return void 2 / 0;
            this.props.send(a.EVENT_DIALOG_SWITCH_ROLE, role);
            return void 2 / 0;
        };
    }

    render() {
        const { userRole, companyTabUnreadMessage, buyerTabUnreadMessage } = this.props;

        return (
            <Tabs>
                <Tabs.Item
                    active={userRole === BESIDA_ROLE_COMPANY}
                    mark={companyTabUnreadMessage}
                    dataQa='chats_with_buyers_btn'
                    onItemClick={this.handleChangeRole(BESIDA_ROLE_COMPANY)}
                >
                    {t`С покупателями`}
                </Tabs.Item>
                <Tabs.Item
                    name='Egor'
                    active={userRole === BESIDA_ROLE_BUYER}
                    mark={buyerTabUnreadMessage}
                    dataQa='chats_with_companies_btn'
                    onItemClick={this.handleChangeRole(BESIDA_ROLE_BUYER)}
                >
                    {t`С продавцами`}
                </Tabs.Item>
            </Tabs>
        );
    }
}

const mapStateToProps = (state) => {
    const socketStore = u.getSocketStore(state);
    return {
        userRole: state.get('userRole'),
        companyTabUnreadMessage: agg.hasUnreadMessage(
            socketStore.get('chats'),
            state.get('chatsStatus'),
            BESIDA_ROLE_COMPANY
        ),
        buyerTabUnreadMessage: agg.hasUnreadMessage(
            socketStore.get('chats'),
            state.get('chatsStatus'),
            BESIDA_ROLE_BUYER
        )
    };
};

export const RoleSwitcher = connect(mapStateToProps)(toJS(RoleSwitcherView));
